export enum RoleFilterKey {
  ALL = 'ALL',
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT',
  AGENCY = 'AGENCY',
  ADVERTISER = 'ADVERTISER',
}
